import { useEffect, useState } from 'react';
import { useDebouncedValue, useFormField } from '@frontend/design-system';

export const useDebouncedSearch = (
  searchQuery: string,
  onSearch: (searchQuery: string) => void,
  isListFetched: boolean
) => {
  const searchFieldProps = useFormField({ type: 'text', value: searchQuery });
  const debouncedValue = useDebouncedValue(searchFieldProps.value, 500);
  const [isFetchingFirstPage, setIsFetchingFirstPage] = useState(true);
  const isDebouncing = searchFieldProps.value !== searchQuery;

  useEffect(() => {
    // The user has finished typing. Start fetching the first page.
    if (!isDebouncing) {
      setIsFetchingFirstPage(true);
    }
  }, [isDebouncing]);

  useEffect(() => {
    // Debounce finished. Update the search query.
    if (debouncedValue !== searchQuery) {
      onSearch(debouncedValue);
    }

    // The first page has finished being fetched.
    if (isFetchingFirstPage && isListFetched) {
      setIsFetchingFirstPage(false);
    }
  }, [debouncedValue, isFetchingFirstPage, isListFetched, onSearch, searchQuery]);

  return {
    searchFieldProps,
    isDebouncing: isDebouncing || isFetchingFirstPage,
  };
};
